import Star from '@/images/Star.svg?react';
import theme from '@/theme';
import styled from '@emotion/styled';

const StarRatingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

const StarButton = styled.button`
    all: unset;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
    :hover {
        transform: scale(1.1);
    }
`;

export const StarRating = ({
    starRating,
    setStarRating,
    numberOfStars,
}: {
    starRating?: number;
    setStarRating: (rating: number) => void;
    numberOfStars: number;
}) => {
    return (
        <StarRatingContainer>
            {Array.from({ length: numberOfStars }, (_, index) => {
                const isActive = starRating !== undefined && index + 1 <= starRating;
                return (
                    <StarButton key={index} onClick={() => setStarRating(index + 1)}>
                        <Star
                            width={40}
                            height={40}
                            color={isActive ? theme.colors.primary.main : theme.colors.white}
                            fill={isActive ? theme.colors.primary.main : theme.colors.secondary.main}
                        />
                    </StarButton>
                );
            })}
        </StarRatingContainer>
    );
};
